export const SCANNER_SUBMIT_ROUTE = `/scanner_submit`;
export const PRACTICE_CHECKOUT_PATHNAME = `submit`;
export const PRACTICE_CHECKOUT_SUBMITTED_PATHNAME = `confirmation`;
